module.exports = __webpack_public_path__ + "media/reskin-images/onboarding--notes-2-08bb5144.png";